import { render, staticRenderFns } from "./ArticleCommentTab.vue?vue&type=template&id=071790ba"
import script from "./ArticleCommentTab.vue?vue&type=script&lang=js"
export * from "./ArticleCommentTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports